import { render } from "./PuxTaskLog.pug?vue&type=template&id=11c3ff26&lang=pug"
import script from "./PuxTaskLog.js?vue&type=script&lang=js"
export * from "./PuxTaskLog.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__